﻿import { defineJQueryPlugin } from '../../../../node_modules/bootstrap/js/src/util/index'
import EventHandler from '../../../../node_modules/bootstrap/js/src/dom/event-handler'
import SelectorEngine from '../../../../node_modules/bootstrap/js/src/dom/selector-engine'
import BaseComponent from '../../../../node_modules/bootstrap/js/src/base-component'

const NAME = 'tagfilter'
const DATA_KEY = 'bs.tagfilter'
const EVENT_KEY = `.${DATA_KEY}`
const DATA_API_KEY = '.data-api'

const EVENT_LOAD_DATA_API = `load${EVENT_KEY}${DATA_API_KEY}`
const EVENT_FOCUS_DATA_API = `focus${EVENT_KEY}${DATA_API_KEY}`
const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`
const EVENT_KEYUP = `keyup${EVENT_KEY}`
const EVENT_CHANGE = `change${EVENT_KEY}`

const SELECTOR_DATA_TOGGLE = '[data-tag-filter]'
const SELECTOR_INPUT = ".tag-filter--input";
const SELECTOR_ACTIVE_TAGS = ".tag-filter--active";
const SELECTOR_INACTIVE_TAGS = ".tag-filter--inactive";

class TagFilter extends BaseComponent {
    constructor(element, config) {
        super(element, config)

        this._inputContainer = SelectorEngine.findOne(SELECTOR_INPUT, element);
        this._activeContainer = SelectorEngine.findOne(SELECTOR_ACTIVE_TAGS, element);
        this._inactiveContainer = SelectorEngine.findOne(SELECTOR_INACTIVE_TAGS, element);

        this._target = `data-tag-filter-${element.getAttribute('data-tag-filter')}`;
        this._tags = this._generateTags();
        this._activeTags = [];
        this._inactiveTags = [...this._tags];

        const input = SelectorEngine.findOne("input", element);
        EventHandler.on(input, EVENT_FOCUS_DATA_API, () => { element.classList.add("focused") });
        EventHandler.on(element, EVENT_CLICK_DATA_API, (event) => { event.stopPropagation(); });
        EventHandler.on(document, EVENT_CLICK_DATA_API, () => element.classList.remove("focused"));
        EventHandler.on(input, EVENT_KEYUP, (event) => {
            this._filterInactiveTags(input.value);
        });
        EventHandler.on(input, EVENT_CHANGE, () => {
            this._filterInactiveTags(input.value);
        });

        this._generateTagButtons();
        this._filterTargets();
    }

    // Getters
    static get NAME() {
        return NAME;
    }

    // Public 


    // Private
    _generateTags() {
        const tags = [];
        const elements = SelectorEngine.find(`[${this._target}]`);
        for (const element of elements) {
            const values = JSON.parse(element.getAttribute(this._target));
            for (const value of values) {
                tags.push(value);
            }
        }
        return tags
            .filter((value, index, self) => {
                return self.indexOf(value) === index;
            })
            .sort();
    }


    _generateTagButtons() {
        for (const tag of this._activeTags) {
            const button = document.createElement("button");
            button.innerText = tag;
            EventHandler.on(button, EVENT_CLICK_DATA_API, (event) => this._toggleTag(event, tag))
            this._activeContainer.appendChild(button);
        }

        for (const tag of this._inactiveTags) {
            const button = document.createElement("button");
            button.innerText = tag;
            EventHandler.on(button, EVENT_CLICK_DATA_API, (event) => this._toggleTag(event, tag))
            this._inactiveContainer.appendChild(button);
        }
    }

    _toggleTag(event, tag) {
        event.preventDefault();

        if (this._activeTags.indexOf(tag) >= 0) {
            this._activeTags = this._activeTags.filter((item) => item !== tag);
            this._inactiveTags.push(tag);
            this._activeContainer.removeChild(event.delegateTarget);
            this._inactiveContainer.appendChild(event.delegateTarget);
        } else {
            this._inactiveTags = this._inactiveTags.filter((item) => item !== tag);
            this._activeTags.push(tag);
            this._inactiveContainer.removeChild(event.delegateTarget);
            this._activeContainer.appendChild(event.delegateTarget);
        }
        this._filterTargets();
    }

    _filterTargets() {
        this._hideEmptyInactiveSection();
        const elements = SelectorEngine.find(`[${this._target}]`);
        if (this._activeTags.length <= 0) {
            this._element.classList.remove("has-active");
            for (const element of elements) {
                element.setAttribute(`${this._target}-hide`, false);
            }
            return;
        }
        this._element.classList.add("has-active");
        for (const element of elements) {
            const values = JSON.parse(element.getAttribute(this._target));
            if (this._activeTags.filter(x => values.includes(x)).length <= 0) {
                element.setAttribute(`${this._target}-hide`, true);
            } else {
                element.setAttribute(`${this._target}-hide`, false);
            }
        }
    }

    _filterInactiveTags(tag) {
        var count = 0;
        for (const button of this._inactiveContainer.children) {
            if (tag.length <= 0) {
                button.classList.remove("d-none");
                continue;
            }
            if (button.innerText.toLowerCase().startsWith(tag.toLowerCase())) {
                button.classList.remove("d-none");
            } else {
                button.classList.add("d-none");
                count++;
            }
        }
        this._hideEmptyInactiveSection();
    }

    _hideEmptyInactiveSection() {
        for (const button of this._inactiveContainer.children) {
            if (!button.classList.contains("d-none")) {
                this._element.classList.add("has-inactive");
                return;
            }
        }
        this._element.classList.remove("has-inactive");
        this._element.classList.remove("focused");
    }
}

/**
 * Data API implementation
 */

EventHandler.on(window, EVENT_LOAD_DATA_API, () => {
    const tagFilters = SelectorEngine.find(SELECTOR_DATA_TOGGLE)

    for (const tagFilter of tagFilters) {
        TagFilter.getOrCreateInstance(tagFilter)
    }
})

EventHandler.on(document, EVENT_CLICK_DATA_API, () => {

})

/**
 * jQuery
 */

defineJQueryPlugin(TagFilter)

export default TagFilter